<template>
  <div>
    <b-card :header-bg-variant="titleVariant !== '' ? titleVariant : ''" no-body>
      <template v-if="!noTitle" v-slot:header>
        <h6 class="header-title">{{title}}</h6>
        <b-button :variant="titleVariant" class="w-100" @click="showContents = !showContents">{{showContents ?
        "Esconder" : "Mostrar"}}</b-button>

      </template>
      <b-collapse v-model="showContents">
        <b-table :id="tableId" ref="table" striped :small="small" :items="getItems" :fields="getFields" class="mb-0 p-3"
          :current-page="currentPage" :per-page="perPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          :busy="isBusy" no-sort-reset show-empty responsive>

          <template v-slot:empty>
            <center>
              <h5>No se encontraron facturas.</h5>
            </center>
          </template>

          <template v-slot:cell(creditor)="row">
            <b-link :to="'/apps/' + $store.getters['auth/userEntity'] + '/creditor/' + row.item.creditor.company_id">
              {{row.item.creditor.name}}
            </b-link>
          </template>

          <template v-slot:cell(action)="row">
            <b-button size="sm" :to="'/apps/' + 'mass_uploads/debt_collections/' + row.item.id">
              Ver
            </b-button>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Cargando...</strong>
            </div>
          </template>
        </b-table>
        <b-card-footer style="display:flex; flex-direction: row; justify-content: flex-end;">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" :aria-controls="tableId"
            class="mb-0"></b-pagination>
        </b-card-footer>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  components: {},
  props: {
    title: {
      type: String,
      default: 'Cargas Masivas'
    },
    tableId: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      default: 'all',
      required: false,
    },
    small: {
      type: Boolean,
      default: false
    },
    selectedCreditorId: {
      type: String,
      default: '',
      required: false
    },
    titleVariant: {
      type: String,
      default: '',
      required: false
    },
    filters: {
      type: Boolean,
      default: false
    },
    noTitle: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showContents: false,
      sortBy: "created_at",
      sortDesc: true,
      fields: [
        {
          key: 'creditor.name',
          label: 'Fecha Vencimiento',
          sortable: true,
        },
        {
          key: 'created_at',
          label: 'Fecha de carga',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Estado',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Acción',
          sortable: false,
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      company: null,
      showFilter: false,
      isBusy: false,
      showStatus: false
    }
  },
  computed: {
    getFields() {
      let updatedFields = this.fields
      return updatedFields
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    getItems(ctx) {
      this.isBusy = true
      var reqUrl = `/api/v1/debt_collection_mass_uploads?status=${this.status}&page=${ctx.currentPage}&limit=${ctx.perPage}&sort_by=${ctx.sortBy}&sort_desc=${ctx.sortDesc}`
      if (this.selectedCreditorId !== '') {
        reqUrl += `&company_id=${this.selectedCreditorId}`
      } else if (this.company !== null) {
        reqUrl += `&company_id=${this.company.company_id}`
      }

      var promise = axios.get(reqUrl)
      return promise.then((response) => {
        const items = response.data.debt_collection_mass_uploads
        items.forEach((item) => {
          item.created_at = new Date(Date.parse(item.created_at))
          let options = {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
          };
          item.created_at = item.created_at.toLocaleString('en-GB', options)
        });
        this.totalRows = response.data.meta.total_count
        this.isBusy = false
        return items || []
      }, () => { return [] })
        .catch((error) => {
          console.log(error)
          this.isBusy = false
        })
    },
    updateTable() {
      this.$refs.table.refresh()
      this.$emit('update')
    },
    clearTable() {
      this.company = null
      this.debtor = null
      this.selectedDebtCollectionStates = []
      this.$refs.table.refresh()
      this.$refs.companyInput.query = "";
      this.$refs.debtorInput.query = "";
      this.invoiceId = ''
    },
    fetch(url) {
      return new Promise((resolve) =>
        setTimeout(() => resolve(this.$http(url)), 1000)
      )
    },
  }
}
</script>
